
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  Hooper,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
  Slide as HooperSlide,
} from 'hooper';
import 'hooper/dist/hooper.css';
import PromoCarouselSlide, { CardOrientations } from './PromoCarouselSlide.vue';
import PromoList from './PromoList.vue';

@Component({
  components: {
    Hooper,
    HooperNavigation,
    HooperPagination,
    HooperSlide,
    PromoCarouselSlide,
    PromoList,
  },
  inheritAttrs: false,
})
export default class PromoCarousel extends Vue {
  @Prop(String)
  readonly id!: string;
  @Prop(String)
  readonly slug!: string;
  @Prop(String)
  readonly filterSlug!: string;
  @Prop(Boolean)
  readonly isSlideshow!: boolean;
  @Prop({ type: Boolean, default: true }) autoPlayCarousel!: boolean;

  mobileBreakpoint = 775;
  orientations = CardOrientations;

  hooperSettings(slideCount: number) {
    return {
      autoPlay: this.autoPlayCarousel,
      infiniteScroll: slideCount > 1 ? true : false,
      itemsToShow: 1,
      mouseDrag: slideCount > 1 ? true : false,
      playSpeed: 5000,
      touchDrag: slideCount > 1 ? true : false,
      transition: 350,
      wheelControl: false,
    };
  }

  get isMobile() {
    return this.$vuetify.breakpoint.width < this.mobileBreakpoint;
  }

  get orientation() {
    return this.isMobile
      ? this.orientations.PORTRAIT
      : this.orientations.LANDSCAPE;
  }
}
